import { useSelector } from 'react-redux'
import { Helmet } from 'react-helmet-async'
import { Box, Heading, Text, Button, Link } from '@chakra-ui/react'

import CreatorMapList from '../components/creator/CreatorMapList'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'

export default function Creator() {

    const { user } = useSelector((state) => state.auth)

    const navigate = useNavigate()

    const [isCreator, setIsCreator] = useState(false)

    useEffect(() => {
        if (!user) {
            navigate('/login')
            return
        }

        if (user.details.subscription.tier === 'creator' || user.details.subscription.tier === 'creator-courtesy') {
            setIsCreator(true)
        }
    }, [user])

    return (
        <>
            <Helmet>
                <title>Creator Mode | TrainLookout</title>
                <meta name="description" content="Create comprehensive and elegant railway maps" />
                <meta name="keywords" content="rail, journey, map, mapping, train, trainlookout, train lookout, trainlookout.com, train lookout.com" />
                <link rel="canonical" href="/creator" />
            </Helmet>

            <Box p={5}>
                {isCreator ? (
                    <>
                        <Box textAlign="center">
                            <Heading as="h1" size="xl" mb={4}>Creator Dashboard</Heading>
                        </Box>

                        <CreatorMapList />
                    </>
                ) : (
                    <Box textAlign="center">
                        <Heading as="h1" size="lg" mb={3}>
                            Creator Mode
                        </Heading>
                        <Text mb={4}>
                            You do not currently have access to our Creator Mode.
                        </Text>
                        <Button colorScheme="blue" variant="outline">
                            <Link href="/pricing">Learn more & pricing</Link>
                        </Button>
                    </Box>
                )}
            </Box>
        </>
    );
}
